import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Form, Icon, Input, Button } from 'antd';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import { baseUrl } from 'config/env.config';
import styles from '../loginForm.less';
import CountDownTimer from './CountDownTimer';


const FormItem = Form.Item;
const cx = classNames.bind(styles);
class LoginForm extends Component {
  state = {
    authMethod: '',
    status: undefined,
    verificationMessage: undefined,
    verificationCodeEditable: false,
    email: '',
  };

  componentDidUpdate(prevProps) {
    const { authMethod } = this.state;
    const { language } = this.props;
    if (language !== prevProps.language) {
      this.setVerificationMessage(authMethod);
    }
  }

  // eslint-disable-next-line react/sort-comp
  handleSubmit = (e) => {
    e.preventDefault();
    const { intl, form, tryLogin } = this.props;
    const { formatMessage } = intl;
    const getUpdatePasswordMessage = days => {
      if (Number.isNaN(days)) return '';
      return formatMessage({ id: 'global.info.needUpdatePasswordInDays' }, { days: days > 0 ? days : 0 });
    };
    form.validateFields((err, values) => {
      if (!err) {
        tryLogin(values, formatMessage({ id: 'global.info.loginSuccess' }), getUpdatePasswordMessage, this.handleTryLoginStatus);
      }
    });
  }

  handleTryLoginStatus = (requestResult) => {
    if (requestResult) {
      // eslint-disable-next-line no-unused-vars
      const { data, statusCode } = requestResult;
      if ([401, 498].includes(statusCode) && 'error' in data) {
        const { form } = this.props;
        form.validateFields((_, values) => {
          form.setFields({
            auth_token: {
              value: values.auth_token,
              errors: [new Error(data.error)],
            },
          });
        });
      }
    }
  }

  handleEmailVerification = e => {
    e.preventDefault();
    if (e.target.value) {
      this.props.showLoading();
      this.getAuthMethod(e.target.value);
      this.setState({ email: e.target.value });
    }
  };

  handleGetCode = () => {
    this.props.showLoading();
    this.getCode(this.state.email);
  };

  getAuthMethod = (email) => {
    const { intl } = this.props;
    const { formatMessage } = intl;
    fetch(`${baseUrl}/admin/auth_method?email=${email}`, {
      method: 'GET',
    }).then(response => {
      if (response.status !== 200) throw new Error(formatMessage({ id: 'global.info.invalidEmail' }));
      this.setState({ status: response.status });
      return response.json();
    }).then(data => this.setState({ authMethod: data.authentication_method }))
      .catch((err) => {
        this.props.form.validateFields((error, values) => {
          this.props.form.setFields({
            auth_token: {
              value: values.auth_token,
              errors: [new Error(err.message)],
            },
          });
        });
      })
      .finally(() => {
        this.props.hideLoading();
      });
  };

  getCode = (email) => {
    this.props.showLoading();
    const formData = new FormData();
    formData.append('email', email);
    fetch(`${baseUrl}/admin/send_auth_token`, {
      method: 'POST',
      body: formData,
    }).then((response) => {
      this.setState({ status: response.status });
      return response.json();
    }).then(() => {
      this.setVerificationMessage(this.state.authMethod);
    }).catch(error => {
      this.props.form.validateFields((_, values) => {
        this.props.form.setFields({
          auth_token: {
            value: values.auth_token,
            errors: [new Error(error.message)],
          },
        });
      });
    })
      .finally(() => {
        this.props.hideLoading();
      });
  };

  onTimerStatusChanged = (timerActivated) => {
    if (timerActivated) {
      this.getCode(this.state.email);
    }
    this.setState({ verificationCodeEditable: true });
  }

  setVerificationMessage = (authMethod) => {
    const { intl } = this.props;
    const { formatMessage } = intl;
    // eslint-disable-next-line no-nested-ternary
    const msg = authMethod === 'email' ? formatMessage({ id: 'global.info.emailAddress' }) : authMethod === 'mobile' ? formatMessage({ id: 'global.info.mobileNumber' }) : '';
    this.setState({ verificationMessage: formatMessage({ id: 'global.info.verificationMessage' }, { msg }) });
  }

  checkFormStatus = () => {
    const { form } = this.props;
    const { getFieldValue } = form;
    const { status, authMethod } = this.state;
    const authTokenValue = getFieldValue('auth_token');
    return status === 200 && !!authMethod && !authTokenValue;
  }

  renderGetCode = () => {
    const { intl } = this.props;
    return (
      <CountDownTimer className={cx('getCodeBtn')} timerStatusChangeHandler={this.onTimerStatusChanged} intl={intl} />
    );
  };

  render() {
    const { form, intl } = this.props;
    const { getFieldError, getFieldDecorator } = form;
    const { formatMessage } = intl;
    const {
      status, verificationMessage, authMethod, verificationCodeEditable
    } = this.state;

    return (
      <Form onSubmit={this.handleSubmit} className={classNames(cx('login-form-wrapper'), 'normalLabel')}>
        <FormattedMessage id="page.Auth.email">
          {text => <span className={cx('login-form-label')}>{text}</span>}
        </FormattedMessage>
        <FormItem className={cx('formItem')}>
          {getFieldDecorator('email', {
            validateTrigger: getFieldError('email') ? 'onChange' : 'onBlur',
            rules: [{ required: true, message: formatMessage({ id: 'page.Auth.inputEmail' }) }],
          })(<Input className={cx('login-form-input')} suffix={<Icon type="user" />} placeholder={formatMessage({ id: 'page.Auth.email' })} onBlur={this.handleEmailVerification} />)}
        </FormItem>
        <FormattedMessage id="page.Auth.password">
          {text => <span className={cx('login-form-label')}>{text}</span>}
        </FormattedMessage>
        <FormItem className={cx('formItem')}>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: formatMessage({ id: 'page.Auth.inputPassword' }) }],
          })(<Input className={cx('login-form-input')} suffix={<Icon type="lock" />} type="password" placeholder={formatMessage({ id: 'page.Auth.password' })} />)}
        </FormItem>
        <div className="text-right">
          <Link to="/auth/forgotPassword">
            <FormattedMessage id="page.Auth.forgetPassword">
              {text => <span className={cx('login-form-forget')}>{text}?</span>}
            </FormattedMessage>
          </Link>
        </div>
        {status === 200 && authMethod !== null &&
        <section className={cx('verification-container')}>
          <FormattedMessage id="page.Auth.verificationTitle">
            {text => <p className={cx('verification-title')}>{text}</p>}
          </FormattedMessage>
          <FormattedMessage id="page.Auth.verificationText">
            {text => <p className={cx('verification-text')}>{text}</p>}
          </FormattedMessage>
          <FormItem className={cx('formItem')}>
            {getFieldDecorator('auth_token', {
            validateTrigger: getFieldError('auth_token') ? 'onChange' : 'onBlur',
            rules: [{ required: true, message: formatMessage({ id: 'global.info.invalidCode' }) }],
            })(<Input className={cx('login-form-input')} disabled={!verificationCodeEditable} suffix={this.renderGetCode()} type="number" placeholder={formatMessage({ id: 'page.Auth.enterVerificationCode' })} />)}
          </FormItem>
          {<div dangerouslySetInnerHTML={{ __html: verificationMessage }} />}
        </section> }
        <FormItem shouldUpdate className={cx('formItem')}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={this.checkFormStatus()}
            className={cx('signInBtn')}
          >
            { formatMessage({ id: 'page.Auth.loginToSandbox' }) }
          </Button>
        </FormItem>
        {status === 200 && authMethod !== null &&
          <FormattedMessage id="page.Auth.verificationSupport">
            {text => <p className={cx('verification-text')}>{text} <a className={cx('verification-email')} href="mailto:support@acy.com">support@acy.com</a></p>}
          </FormattedMessage>}
      </Form>
    );
  }
}
const mapStateToProps = ({ global }) => ({
  language: global.language,
});
const contextTypes = { store: PropTypes.object };
LoginForm.contextTypes = contextTypes;

export default connect(mapStateToProps)(Form.create()(injectIntl(LoginForm)));



// WEBPACK FOOTER //
// ./src/views/LoginForm/components/LoginForm.jsx